import { useBrandPageCartStateContext } from "../../contexts/BrandPageCartStateContext";

interface FetchDisplayPromoProgressFunction {
  (): void;
}

export const useFetchDisplayPromoProgress =
  (): FetchDisplayPromoProgressFunction => {
    const { brandCartViewState } = useBrandPageCartStateContext();
    return () => {
      return brandCartViewState.fetchDisplayPromoProgress();
    };
  };
